/* Le banc. Un seul role : montrer un traitement a la fois, et savoir
   rejouer son animation — sans quoi la comparaison est impossible.

   Le piege, decouvert a l'essai et non suppose : rejouer une animation impose
   de reposer le HTML d'origine, ce qui DETRUIT les elements que
   l'IntersectionObserver du traitement surveillait. Son script, lui, n'a
   tourne qu'une fois au chargement : les elements neufs ne sont jamais
   observes, la classe qui declenche l'animation n'arrive jamais, et l'image
   reste a opacite zero — invisible pour de bon. C'est ce qui est arrive a
   « Souffle » sur les quatre collections.

   D'ou ce registre : chaque traitement depose sa fonction d'initialisation
   dans window.__anInit, et le banc les rappelle toutes apres chaque remise
   en place. */
window.__anInit = window.__anInit || [];
window.__anDemarrer = function () {
  var racine = document.querySelector('.an');
  if (!racine) return;
  var NOTES = window.__anNotes || {};
  var note = racine.querySelector('#anNote');
  var plus = racine.querySelector('#anPlusC');
  var boutons = racine.querySelectorAll('.an-choix button');

  var copies = [];
  Array.prototype.forEach.call(racine.querySelectorAll('.an-vue'), function (v) {
    copies.push({ el: v, cle: v.getAttribute('data-vue'), html: v.innerHTML });
  });

  function reveiller() {
    (window.__anInit || []).forEach(function (f) { try { f(); } catch (e) { } });
  }

  function rejouer(nom) {
    copies.forEach(function (o) { if (o.cle === nom) o.el.innerHTML = o.html; });
    /* Deux images d'attente : le navigateur doit avoir pris acte du HTML neuf
       avant que les observateurs ne le mesurent, sinon ils le trouvent a une
       taille nulle et ne declenchent rien. */
    requestAnimationFrame(function () { requestAnimationFrame(reveiller); });
  }

  function montrer(nom) {
    Array.prototype.forEach.call(boutons, function (b) {
      b.setAttribute('aria-pressed',
        b.getAttribute('data-t') === nom ? 'true' : 'false');
    });
    Array.prototype.forEach.call(racine.querySelectorAll('.an-vue'), function (v) {
      v.hidden = v.getAttribute('data-vue') !== nom;
    });
    var n = NOTES[nom] || { t: '', p: '' };
    note.innerHTML = n.t; plus.innerHTML = n.p;
    racine.__vue = nom;
    rejouer(nom);
  }

  Array.prototype.forEach.call(boutons, function (b) {
    b.addEventListener('click', function () { montrer(b.getAttribute('data-t')); });
  });
  racine.querySelector('#anRejouer').addEventListener('click', function () {
    rejouer(racine.__vue);
  });
  montrer(racine.querySelector('.an-choix button').getAttribute('data-t'));
};


/* --- Le mot geant --- */
window.__anInit.push(function () { (function(){
  /* Le JS ne fait qu'une chose : marquer les blocs, puis les allumer au bon
     moment. Tant qu'il n'a pas tourné, la page est complète et lisible :
     les états de départ (lettres sous la ligne, œuvre à opacity 0) ne sont
     posés par le CSS que sous la classe .mgeo-js, jamais par défaut. */

  /* Mouvement réduit ou navigateur sans observer : on ne masque rien,
     on ne marque rien, tout reste visible tel quel. */
  var doux = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (doux || !('IntersectionObserver' in window)) { return; }

  var oeil = new IntersectionObserver(function(entrees){
    for (var j = 0; j < entrees.length; j++) {
      if (entrees[j].isIntersecting) {
        entrees[j].target.classList.add('mgeo-on');
        /* une seule fois : rien ne rejoue au défilement inverse */
        oeil.unobserve(entrees[j].target);
      }
    }
  }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

  function allumer(racine){
    var blocs = (racine || document).querySelectorAll('.mgeo-bloc');
    for (var i = 0; i < blocs.length; i++) {
      /* jamais deux fois le même bloc : la classe sert de témoin */
      if (blocs[i].classList.contains('mgeo-js')) { continue; }
      blocs[i].classList.add('mgeo-js');
      oeil.observe(blocs[i]);
    }
  }

  /* CORRECTION F — la version précédente lisait le DOM immédiatement. Placée
     dans le <head> sans defer, ou exécutée avant le rendu de la section,
     elle trouvait zéro bloc, sortait, et l'animation disparaissait en
     silence : la page restait correcte, mais la direction s'évaporait sans
     le moindre signal. On attend donc que le DOM soit prêt. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ allumer(document); });
  } else {
    allumer(document);
  }

  /* éditeur de thème : une section re-rendue n'était jamais observée */
  document.addEventListener('shopify:section:load', function(e){
    allumer(e.target || document);
  });
})(); });

/* --- La planche contact --- */
window.__anInit.push(function () { (function(){
  'use strict';
  /* Le JS ne fait qu'une chose : poser .plc--js (etat de depart)
     puis .plc--vu a l'entree dans le champ. Sans lui, la planche
     est deja entierement visible : rien ne depend du script. */

  var obs = null;

  function observateur(){
    if (obs || !('IntersectionObserver' in window)) { return obs; }
    /* threshold:0 et non 0.18 : le seuil en pourcentage est un pari
       sur la hauteur. Une planche plus haute que ~5 fois la fenetre
       n'atteint JAMAIS 18 % d'intersection et resterait a opacity 0
       pour toujours — exactement le piege que le CSS evite par
       ailleurs. Avec 0, c'est le rootMargin bas qui decide du
       moment, et il ne depend d'aucune hauteur. */
    obs = new IntersectionObserver(function(entrees){
      for (var k = 0; k < entrees.length; k++) {
        if (entrees[k].isIntersecting) {
          entrees[k].target.classList.add('plc--vu');
          /* Une planche ne se trace qu'une fois. */
          obs.unobserve(entrees[k].target);
        }
      }
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
    return obs;
  }

  function demarrer(racine){
    var hote = racine || document;
    if (!hote.querySelectorAll) { return; }
    var planches = hote.querySelectorAll('.plc');
    if (!planches.length) { return; }
    var o = observateur();

    for (var i = 0; i < planches.length; i++) {
      var planche = planches[i];
      /* Le verrou est par element, pas global : sinon un premier
         passage sur une page a plusieurs collections marquait le
         script comme « fait » et les sections parsees ensuite
         n'etaient jamais animees, a cote de sections qui l'etaient. */
      if (planche.classList.contains('plc--js')) { continue; }
      /* On masque le plus tot possible pour eviter tout clignotement. */
      planche.classList.add('plc--js');
      if (o) {
        o.observe(planche);
      } else {
        /* Navigateur sans IntersectionObserver : on montre tout, point. */
        planche.classList.add('plc--vu');
      }
    }
  }

  demarrer(document);

  /* L'ecoute est toujours posee : une planche situee plus bas dans
     le document n'existait pas encore au premier passage. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ demarrer(document); });
  }

  /* Editeur de theme : une section reinjectee doit s'animer aussi. */
  document.addEventListener('shopify:section:load', function(e){ demarrer(e.target); });
})(); });

/* --- La cimaise --- */
window.__anInit.push(function () { (function(){
  /* LA CIMAISE — le JS ne fait que trois choses :
     poser les etats de depart, declencher a l'entree dans l'ecran,
     et rendre la molette utile sur ordinateur. */
  var racines = document.querySelectorAll('.cim');
  if (!racines.length) return;
  var doux = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(racines, function(cim){
    if (cim.getAttribute('data-cim-pret')) return;
    cim.setAttribute('data-cim-pret', '1');

    var rail  = cim.querySelector('[data-cim-rail]');
    var jauge = cim.querySelector('[data-cim-jauge]');

    /* Les etats de depart (opacity 0, translations) ne sont poses QUE
       si ce script tourne. Sans JS, la page est deja dans son etat
       final : aucun element ne peut rester invisible pour toujours. */
    cim.classList.add('cim-anime');

    if (doux || !('IntersectionObserver' in window)) {
      cim.classList.add('cim-vu');
    } else {
      var io = new IntersectionObserver(function(entrees){
        for (var i = 0; i < entrees.length; i++){
          if (entrees[i].isIntersecting){
            cim.classList.add('cim-vu');
            io.disconnect();
            break;
          }
        }
      }, { threshold: 0.18 });
      io.observe(cim);

      /* CORRIGE — filet de securite. Si l'observateur ne se declenche
         jamais (module masque au chargement, onglet en arriere-plan,
         module plus haut que la fenetre sur un ecran tres court), la
         classe cim-anime restait posee sans cim-vu et TOUT restait a
         opacity 0 pour toujours. On revele au bout d'une seconde. */
      setTimeout(function(){
        if (!cim.classList.contains('cim-vu')){
          cim.classList.add('cim-vu');
          io.disconnect();
        }
      }, 1000);
    }

    if (!rail) return;

    /* Jauge de progression : une seule ecriture de transform par frame. */
    var attente = false;
    var pousse = false;
    function maj(){
      attente = false;
      var max = rail.scrollWidth - rail.clientWidth;
      var p = max > 0 ? rail.scrollLeft / max : 0;
      if (jauge) jauge.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      /* CORRIGE : classList.add etait rappele a chaque frame de
         defilement alors que l'etat ne peut changer qu'une fois. */
      if (!pousse && rail.scrollLeft > 8){
        pousse = true;
        cim.classList.add('cim-pousse');
      }
    }
    function demander(){
      if (!attente){ attente = true; requestAnimationFrame(maj); }
    }
    rail.addEventListener('scroll', demander, { passive: true });
    /* CORRIGE : au redimensionnement, scrollWidth change ; sans cela la
       jauge restait figee sur une proportion devenue fausse. */
    window.addEventListener('resize', demander, { passive: true });
    maj();

    /* La molette pousse le rail — mais on rend la main a la page des
       que le rail est en butee, dans le sens demande. Jamais de
       defilement confisque en butee, et on ne touche pas aux gestes
       lateraux du pave tactile (deltaX dominant : on ne fait rien). */
    rail.addEventListener('wheel', function(e){
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 1) return;
      /* CORRIGE — deltaMode : 0 = pixels, 1 = lignes, 2 = pages. Le cas 2
         n'etait pas traite : un "page down" ne poussait le rail que d'un
         pixel tout en bloquant la page, le mur semblait fige. */
      var pas = 1;
      if (e.deltaMode === 1) pas = 16;
      else if (e.deltaMode === 2) pas = rail.clientWidth;
      var d = e.deltaY * pas;
      var pos = rail.scrollLeft;
      if ((d > 0 && pos >= max - 1) || (d < 0 && pos <= 1)) return;
      e.preventDefault();
      rail.scrollLeft = pos + d;
    }, { passive: false });
  });
})(); });

/* --- Hors registre --- */
window.__anInit.push(function () { (function(){
  /* Le JS ne fait qu'une chose : poser la classe .trc-pret (qui
     ACTIVE les états cachés) puis .trc-on à l'entrée en vue.
     Conséquence voulue : si le JS ne tourne pas, si le navigateur
     n'a pas IntersectionObserver, ou si l'utilisateur a demandé
     moins de mouvement, aucun état caché n'est jamais posé et la
     carte s'affiche complète. Rien ne peut rester invisible.

     PLACEMENT — c'est une contrainte, pas un détail : ce script
     doit être en fin de <body> ou chargé en `defer`. Le masquage
     étant posé par le JS, un chargement trop tardif ferait
     clignoter la carte du haut de page (visible, puis masquée,
     puis réanimée) ; un chargement dans un <head> non différé ne
     trouverait aucune carte et l'animation ne jouerait jamais —
     dégradation propre, mais l'effet serait perdu. */
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cartes = document.querySelectorAll('.trc-carte:not([data-trc-vu])');
  if (!cartes.length) return;

  var io = new IntersectionObserver(function(entrees){
    for (var i = 0; i < entrees.length; i++){
      if (entrees[i].isIntersecting){
        entrees[i].target.classList.add('trc-on');
        /* Une seule fois : le geste ne se rejoue pas au défilement
           inverse, sinon il devient un tic. */
        io.unobserve(entrees[i].target);
      }
    }
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  for (var j = 0; j < cartes.length; j++){
    cartes[j].setAttribute('data-trc-vu', '1');
    cartes[j].classList.add('trc-pret');
    io.observe(cartes[j]);
  }
})(); });

/* --- La morsure --- */
window.__anInit.push(function () { /* LA MORSURE — déclenchement de l'entrée.
   Le script pose lui-même .mors--anim : si le JavaScript ne s'exécute pas,
   aucun état initial n'est appliqué et la page reste entièrement visible.
   Rien ne peut rester bloqué à opacity 0. */
(function(){
  "use strict";

  var io = null;

  function voir(el){ el.classList.add('mors--vu'); }

  function init(){
    var lots = document.querySelectorAll('.mors:not(.mors--anim)');
    if (!lots.length) return;

    if (io === null && 'IntersectionObserver' in window){
      io = new IntersectionObserver(function(entrees, obs){
        for (var i = 0; i < entrees.length; i++){
          if (entrees[i].isIntersecting){
            voir(entrees[i].target);
            /* une seule fois : l'observateur se vide au fil du défilement */
            obs.unobserve(entrees[i].target);
          }
        }
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    }

    for (var j = 0; j < lots.length; j++){
      var el = lots[j];
      el.classList.add('mors--anim');
      if (io){
        io.observe(el);
      } else {
        /* navigateur sans IntersectionObserver : on montre tout, tout de suite */
        voir(el);
      }
    }
  }

  /* LE FILET DE SÉCURITÉ. rootMargin retire 8 % en bas de la racine : un bloc
     qui se retrouve dans cette bande sur une page qui NE PEUT PLUS DÉFILER
     (page courte, dernier bloc juste au-dessus du pied) n'intersecte jamais
     et resterait à opacity 0 POUR TOUJOURS — exactement l'interdit du cahier
     des charges. Au chargement complet, on révèle donc tout bloc déjà présent
     à l'écran mais encore non vu. Une seule lecture de géométrie, une fois. */
  function filet(){
    var restes = document.querySelectorAll('.mors--anim:not(.mors--vu)');
    for (var k = 0; k < restes.length; k++){
      var r = restes[k].getBoundingClientRect();
      if (r.top < (window.innerHeight || 0) && r.bottom > 0){ voir(restes[k]); }
    }
  }

  /* Tout de suite : les blocs déjà analysés ne clignotent pas. Sans cet appel
     immédiat, un script placé en fin de page (ou en defer) laissait le
     navigateur peindre le bloc entièrement visible AVANT que .mors--anim
     n'arrive : flash, retour à opacity 0, puis animation.
     init() est idempotente grâce au :not(.mors--anim), on peut la rappeler. */
  init();

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }

  if (document.readyState === 'complete'){
    filet();
  } else {
    window.addEventListener('load', function(){ init(); filet(); });
  }
})(); });

/* --- La pile de tirages --- */
window.__anInit.push(function () { (function(){
  /* La pile de tirages. Le script n'ajoute QUE du mouvement : sans lui,
     l'eventail est deja ouvert, les images sont visibles, le compteur est
     juste (Liquid l'ecrit) et le lien marche. */

  var piles = document.querySelectorAll('.pil');
  if(!piles.length){ return; }

  var doux = window.matchMedia
          && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(piles, function(pil){

    var scene = pil.querySelector('.pil-scene');
    if(!scene){ return; }

    /* On range les tirages par rang initial : le DOM met les dessous avant. */
    var cartes = Array.prototype.slice.call(scene.querySelectorAll('.pil-t'));
    cartes.sort(function(a, b){
      return (parseFloat(a.style.getPropertyValue('--r')) || 0)
           - (parseFloat(b.style.getPropertyValue('--r')) || 0);
    });

    var cpt = pil.querySelector('.pil-cpt');
    var tot = pil.querySelector('.pil-tot');
    var deux = function(n){ return (n < 10 ? '0' : '') + n; };
    /* Filet de securite si le HTML vient d'un cache plus ancien que le rendu :
       le total affiche suit toujours le nombre de tirages reellement peints. */
    if(tot){ tot.textContent = '/ ' + deux(cartes.length); }

    /* --- Entree : on arme AVANT la premiere peinture, puis on ouvre. ------ */
    if(!doux && 'IntersectionObserver' in window){
      pil.classList.add('pil-armee', 'pil-entree');
      var oeil = new IntersectionObserver(function(entrees){
        entrees.forEach(function(e){
          if(!e.isIntersecting){ return; }
          /* Les deux classes changent dans la meme frame : la transition est
             lue sur l'etat d'arrivee (.pil-on), donc elle se declenche bien.
             C'est aussi l'instant ou le CSS accorde le will-change, via
             .pil-entree.pil-on : la promotion en couche composite ne dure
             donc que l'animation, et pas tant qu'on n'a pas defile. */
          pil.classList.remove('pil-armee');
          pil.classList.add('pil-on');
          /* On retire le will-change et les delais d'entree : le survol et le
             feuilletage doivent repondre au quart de tour. */
          setTimeout(function(){ pil.classList.remove('pil-entree'); }, 660);
          oeil.unobserve(e.target);
        });
      }, { threshold:0.15, rootMargin:'0px 0px -8% 0px' });
      oeil.observe(pil);
    }

    /* --- Feuilletage : le dessus part a gauche, puis revient DESSOUS. ----- */
    /* Un seul tirage : Liquid n'a pose ni role, ni tabindex, ni promesse de
       geste dans le pied. On n'arme donc rien du tout. */
    if(cartes.length < 2){ return; }

    var occupe = false;
    var pos = 0;

    function ranger(){
      cartes.forEach(function(el, i){
        el.style.setProperty('--r', String(i));
        el.style.zIndex = String(14 - i);
        if(i === 0){ el.classList.add('pil-dessus'); }
        else { el.classList.remove('pil-dessus'); }
      });
      pos = (pos + 1) % cartes.length;
      if(cpt){ cpt.textContent = deux(pos + 1); }
    }

    function feuilleter(){
      if(occupe){ return; }
      occupe = true;
      var haut = cartes[0];

      /* Temps 1 : il se souleve vers la gauche, au-dessus du reste du papier.
         30 reste sous le titre (41) : le tirage passe SOUS le titre, ce qui
         est justement le hors-cadre voulu. */
      haut.style.zIndex = '30';
      haut.classList.add('pil-part');

      var temps2 = function(){
        /* Temps 2 : il redescend d'un cran de z et rejoint le fond de pile :
           visuellement, il se reglisse sous les autres. */
        haut.classList.remove('pil-part');
        cartes.push(cartes.shift());
        ranger();
        setTimeout(function(){ occupe = false; }, doux ? 0 : 300);
      };

      if(doux){ temps2(); } else { setTimeout(temps2, 230); }
    }

    scene.addEventListener('click', feuilleter);
    scene.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'){
        e.preventDefault();
        feuilleter();
      }
    });
  });
})(); });

/* --- La coupe diagonale --- */
window.__anInit.push(function () { /* La coupe diagonale — declenchement a l'apparition. INCHANGE : relu ligne
   a ligne, aucun defaut trouve.
   A placer en fin de <body> : la classe dgl--js doit etre posee avant
   que la carte n'entre dans l'ecran, sinon un bref flash est possible. */
(function(){
  var cartes = document.querySelectorAll('[data-dgl]');
  if(!cartes.length){ return; }

  var i;
  var doux = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Mouvement reduit, ou navigateur sans IntersectionObserver :
     on n'ajoute jamais l'etat cache, tout reste visible. */
  if(doux || !('IntersectionObserver' in window)){
    for(i = 0; i < cartes.length; i++){ cartes[i].classList.add('dgl--on'); }
    return;
  }

  /* dgl--js est ce qui autorise l'etat cache : sans JS, rien n'est masque. */
  for(i = 0; i < cartes.length; i++){ cartes[i].classList.add('dgl--js'); }

  var obs = new IntersectionObserver(function(entrees){
    for(var k = 0; k < entrees.length; k++){
      if(entrees[k].isIntersecting){
        entrees[k].target.classList.add('dgl--on');
        obs.unobserve(entrees[k].target); /* une seule fois, puis on libere */
      }
    }
  }, {
    /* seuil 0 : une carte portrait plus haute que l'ecran doit quand meme
       se declencher. La marge basse laisse la lame partir juste avant
       que la carte ne soit pleinement lue. */
    threshold: 0,
    rootMargin: '0px 0px -12% 0px'
  });

  for(i = 0; i < cartes.length; i++){ obs.observe(cartes[i]); }
})(); });

/* --- Bordereau --- */
window.__anInit.push(function () { (function () {
  'use strict';
  var cartes = document.querySelectorAll('.brt');
  if (!cartes.length) { return; }

  // Mouvement reduit ou navigateur sans IntersectionObserver : on ne pose
  // JAMAIS l'etat cache. La carte reste telle quelle, entierement visible.
  var doux = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (doux || !('IntersectionObserver' in window)) { return; }

  var hauteurVue = function () {
    return window.innerHeight || document.documentElement.clientHeight || 0;
  };

  // CORRECTION 1 — le clignotement. L'ancienne version posait .brt--anim sur
  // TOUTES les cartes, y compris celles deja peintes en haut de page : visible,
  // puis cachee, puis revelee. On ne cache donc que ce qui est encore sous la
  // ligne de flottaison ; une carte deja a l'ecran n'est pas touchee.
  var cachees = [];
  var i, r;
  var h0 = hauteurVue();
  for (i = 0; i < cartes.length; i++) {
    r = cartes[i].getBoundingClientRect();
    if (r.top >= h0) {
      cartes[i].classList.add('brt--anim');
      cachees.push(cartes[i]);
    }
  }
  if (!cachees.length) { return; } // tout est deja visible : rien a observer

  var obs = null;
  var enAttente = false;
  var restantes = cachees.length;

  var arreter = function () {
    window.removeEventListener('scroll', surDefilement);
    window.removeEventListener('resize', surDefilement);
    if (obs) { obs.disconnect(); }
  };

  var reveler = function (el) {
    if (el.classList.contains('brt--vu')) { return; }
    el.classList.add('brt--vu');
    if (obs) { obs.unobserve(el); }
    restantes--;
    if (restantes <= 0) { arreter(); } // plus rien a surveiller, on lache tout
  };

  // Rattrapage : revele ce qui est REELLEMENT a l'ecran et pas encore revele.
  var rattraper = function () {
    var h = hauteurVue(), k, b;
    for (k = 0; k < cachees.length; k++) {
      if (cachees[k].classList.contains('brt--vu')) { continue; }
      b = cachees[k].getBoundingClientRect();
      if (b.top < h && b.bottom > 0) { reveler(cachees[k]); }
    }
  };

  var surDefilement = function () {
    if (enAttente) { return; }
    enAttente = true;
    window.requestAnimationFrame(function () { enAttente = false; rattraper(); });
  };

  obs = new IntersectionObserver(function (entrees) {
    for (var k = 0; k < entrees.length; k++) {
      if (entrees[k].isIntersecting) {
        reveler(entrees[k].target); // reveler() se charge du unobserve
      }
    }
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

  for (i = 0; i < cachees.length; i++) { obs.observe(cachees[i]); }

  // CORRECTION 2 — le filet de securite tuait l'animation. L'ancienne version
  // revelait TOUTES les cartes au bout de 2,5 s, y compris celles situees dix
  // ecrans plus bas : des la troisieme seconde, plus une seule carte
  // n'apparaissait au defilement. Le geste etait mort avant d'avoir servi.
  // Ici le rattrapage est borne a l'ecran, et double d'un ecouteur de
  // defilement passif etrangle par requestAnimationFrame : si l'observateur ne
  // tire jamais (page masquee, bug de rendu), rien ne peut rester invisible
  // sous les yeux de quelqu'un — sans sacrifier l'apparition au defilement.
  // L'ecouteur se debranche seul des que tout est revele.
  window.addEventListener('scroll', surDefilement, { passive: true });
  window.addEventListener('resize', surDefilement, { passive: true });
  window.setTimeout(rattraper, 2500);
})(); });

/* --- La vitrine --- */
window.__anInit.push(function () { (function () {
  'use strict';

  /* Deux portes fermees d'entree de jeu. Si l'une des deux se referme, rien
     n'est arme du tout : la vitrine reste affichee entiere, dans son etat
     final. Aucun element ne peut rester a opacity:0. */
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Au-dela de 22 caracteres, on anime par MOT et non par lettre : sinon le
     dernier fragment depasserait les 600 ms imposees. */
  var MAX_LETTRES = 22;

  /* CORRECTION. Au-dela de huit signes, un mot ne tient plus dans la carte a
     320 px (titre a 39,7 px, 266 px utiles) : avec white-space:nowrap il
     sortait du cadre et, comme aucun ancetre ne clippe, faisait defiler la
     PAGE entiere horizontalement. Ces mots-la recoivent .vitr__mot--long, qui
     autorise la coupure uniquement si elle est necessaire. Les titres courants
     gardent leur mot d'un seul tenant. */
  var MAX_MOT_SUR = 8;

  /* Le suivi du curseur est un luxe d'ordinateur. Sur telephone, aucun
     ecouteur n'est pose : le tactile ne paie que l'entree. */
  var POINTEUR_FIN = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Un seul observateur pour toute la page, partage par toutes les vitrines,
     meme si ce fragment est inclus vingt-quatre fois dans une grille. */
  var obs = window.__vitrObs;
  if (!obs) {
    obs = window.__vitrObs = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        if (entrees[i].isIntersecting) {
          entrees[i].target.classList.add('vitr--ouverte');
          /* On arrete d'observer : la vitrine ne s'ouvre qu'une fois. */
          window.__vitrObs.unobserve(entrees[i].target);
        }
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  }

  /* Decoupe du titre. Les lettres n'ont AUCUNE espace entre elles, ce qui
     permet a la plupart des lecteurs d'ecran de recoller le mot. */
  function decouper(el) {
    var texte = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!texte) return;

    var mots = texte.split(' ');
    var parLettre = texte.replace(/\s/g, '').length <= MAX_LETTRES;
    var frag = document.createDocumentFragment();
    var indice = 0;

    for (var m = 0; m < mots.length; m++) {
      var mot = document.createElement('span');
      /* Un mot long redevient secable : il ne se coupera que s'il ne tient
         pas, mais il ne pourra plus faire deborder la carte. */
      mot.className = mots[m].length > MAX_MOT_SUR
        ? 'vitr__mot vitr__mot--long'
        : 'vitr__mot';

      if (parLettre) {
        for (var c = 0; c < mots[m].length; c++) {
          var lettre = document.createElement('span');
          lettre.className = 'vitr__l';
          lettre.style.setProperty('--vitr-i', String(indice++));
          lettre.textContent = mots[m].charAt(c);
          mot.appendChild(lettre);
        }
      } else {
        var bloc = document.createElement('span');
        bloc.className = 'vitr__l';
        bloc.style.setProperty('--vitr-i', String(indice++));
        bloc.textContent = mots[m];
        mot.appendChild(bloc);
      }

      frag.appendChild(mot);
      /* L'espace reste un vrai noeud texte : la coupure de ligne naturelle
         entre les mots est preservee, y compris a 320 px. */
      if (m < mots.length - 1) frag.appendChild(document.createTextNode(' '));
    }

    el.textContent = '';
    el.appendChild(frag);
  }

  /* Derive des reflets sous le curseur. Deux variables ecrites au rythme de
     l'ecran, jamais plus. La boite est mesuree a l'entree et non a chaque
     mouvement : aucune lecture de mise en page en boucle. */
  function suivre(carte) {
    var boite = null;
    var dernier = null;
    var tache = 0;

    carte.addEventListener('pointerenter', function () {
      boite = carte.getBoundingClientRect();
    }, { passive: true });

    carte.addEventListener('pointermove', function (ev) {
      if (!boite) boite = carte.getBoundingClientRect();
      dernier = ev;
      if (tache) return;
      tache = requestAnimationFrame(function () {
        tache = 0;
        if (!boite || !dernier) return;
        var x = ((dernier.clientX - boite.left) / boite.width) * 2 - 1;
        var y = ((dernier.clientY - boite.top) / boite.height) * 2 - 1;
        carte.style.setProperty('--vitr-mx', Math.max(-1, Math.min(1, x)).toFixed(3));
        carte.style.setProperty('--vitr-my', Math.max(-1, Math.min(1, y)).toFixed(3));
      });
    }, { passive: true });

    carte.addEventListener('pointerleave', function () {
      boite = null;
      dernier = null;
      /* Retour au repos : la transition CSS ramene les deux plans en douceur. */
      carte.style.setProperty('--vitr-mx', '0');
      carte.style.setProperty('--vitr-my', '0');
    }, { passive: true });
  }

  /* Le marqueur data-vitr-prete rend l'initialisation idempotente : le
     fragment peut etre inclus autant de fois qu'il y a de collections, chaque
     vitrine n'est preparee qu'une seule fois. */
  var cartes = document.querySelectorAll('.vitr:not([data-vitr-prete])');

  for (var i = 0; i < cartes.length; i++) {
    var carte = cartes[i];
    carte.setAttribute('data-vitr-prete', '1');

    var titre = carte.querySelector('[data-vitr-titre]');
    if (titre) decouper(titre);

    /* On arme APRES la decoupe : les etats de depart sont poses en une seule
       fois, pendant l'analyse du document, avant la premiere peinture. */
    carte.classList.add('vitr--armee');

    obs.observe(carte);
    if (POINTEUR_FIN) suivre(carte);
  }
})(); });

/* Tout est enregistre : le banc peut ouvrir. */
window.__anDemarrer();
